import L from 'leaflet'
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

// Vite casse les chemins d’icônes par défaut de Leaflet
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
})

export class Map {
  constructor () {
    document.querySelectorAll('[data-map]').forEach((el) => this.mount(el))
  }

  mount (el) {
    const lat = parseFloat(el.dataset.lat)
    const lng = parseFloat(el.dataset.lng)
    const zoom = parseInt(el.dataset.zoom || '15', 10)
    const label = el.dataset.label || ''

    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return
    }

    const map = L.map(el, {
      scrollWheelZoom: false,
      attributionControl: true,
    }).setView([lat, lng], zoom)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map)

    const marker = L.marker([lat, lng]).addTo(map)
    if (label) {
      marker.bindPopup(label)
    }

    // ponytail: fix taille 0 si le conteneur n’était pas encore layouté
    requestAnimationFrame(() => map.invalidateSize())
  }
}
